import React from "react";
import { noSpecialCharacters } from "../utils/transformText";

export const BoutonSonMarin = ({id, x, y, img, name, selected, setSelected, setSoundPlaying}) => {

	const handleClick = () => {
		setSelected(selected === id ? null : id);
		setSoundPlaying(true);
	};


  return (
    <div className="container-bouton-son-marin" style={{ left: `${x}%`, top: `${y}%`}}>
			<button className={`btn son-marin ${noSpecialCharacters(name)} ${selected === id ? 'selected' : ''}`} onClick={handleClick}>
				<img src={img} alt={name} />
			</button>
		</div>
  );
}